let priceUrlParam = '' //used to fix ranged price filtering

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      // FacetFiltersForm.filterData.some(filterDataUrl)
      //   ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
      //   : FacetFiltersForm.renderSectionFromFetch(url, event);

      FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        extraFiltersSettings.fetchFilters(event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    extraFiltersSettings.fetchFilters(event);
  }

  static renderProductGridContainer(html, event) {
    document.getElementById('ProductCount').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    document.getElementById('ProductGridContainer').querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.add('scroll-trigger--cancel');});

    extraFiltersSettings.resetPageNumber('#product-grid', html);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);

    //workaround to have specific price not range
    if (priceUrlParam != '') {
      //set params
      let newURL = window.location.href + (window.location.href.includes('?') ? '&' : '?') + priceUrlParam;
          newURL = newURL.replace('&&', '&');
      window.history.pushState("", "", newURL);
    }
    //END workaround to have specific price not range
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form')?.id === 'FacetFiltersFormMobile';
      sortFilterForms.forEach((form) => {

        if (form.id == 'price-filter') {
          //create a dummy form and use that to create URL search params
          //price filter returns by a specific price and not a range
          var formData = new FormData();
          let max = form.elements[0].value; // set as firt price that is always the lowest
          let min = form.elements[form.elements.length - 1].value; //set as last price that is always the biggest
          for (let i = 0; i < form.elements.length; i++) {
            if (form.elements[i].checked) {
              max = form.elements[i].value > max ? form.elements[i].value : max;
              min = form.elements[i].value < min ? form.elements[i].value : min;
            }
          }
          if (min > max) {
            let auxMax = max;
            max = min;
            min = auxMax
          }
          var obj = {
            'filter.v.price.lte': max,
            'filter.v.price.gte': min
          };
          for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
              formData.append(key, obj[key]);
            }
          }
          
          // Code commented for now, be back later to it cause we will need to have a price range - ISSUE: Added multiple filters to the URL
          //-----------------------------------------------------------------------------------------------------------
          //have active price filter ?
          // let isOneChecked = false;
          // form.querySelectorAll('input').forEach(el => {
          //   if (el.checked) {
          //     isOneChecked = true;
          //   }
          // })
          // if (isOneChecked) {
          //   forms.push(new URLSearchParams(formData).toString())
          // }
          //-----------------------------------------------------------------------------------------------------------

          //workaround to have specific price not range
          let priceUrlParamValue = ''; //used to have specific price not range, ex: '29-39' - show only the $29 products and $39
          form.querySelectorAll('input').forEach(el => {
            if (el.checked) {
              priceUrlParamValue += priceUrlParamValue == '' ? el.value : `-${el.value}`
            }
          })
          priceUrlParam = priceUrlParamValue != '' ? `filter-price=${priceUrlParamValue}` : '';
          //END workaround to have specific price not range
        }
        if (form.id == 'scents-filter') {
          forms.push(this.createSearchParams(form));
        }
        if (form.id == 'brands-filter') {
          forms.push(this.createSearchParams(form));
        }
        if (form.id == 'genders-filter') {
          forms.push(this.createSearchParams(form));
        }
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));

          }
        }
        else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }

      });

      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

//custom dossier logic
class ExtraFiltersSettings {
  // Initialization method that calls all the individual functions
  init() {    
    this.deactivateFilters();
    this.filterFilters();
    this.toggleDossierFilter();
    this.toggleDossierSort();
    this.changeDossierSortTitle();
    this.toggleDossierFilterwidgets();
  }

  resetPageNumber(sectionId, html) {
    //update nr of pages
    document.querySelector(sectionId).dataset.pages = new DOMParser().parseFromString(html, 'text/html').querySelector(sectionId).dataset.pages;

    //reset page numer
    document.querySelector(sectionId).classList.add('pageOne');
  
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    if (typeof initializeScrollZoomAnimationTrigger === 'function') initializeScrollZoomAnimationTrigger(html.innerHTML);
  
    //fix scroll-trigger--cancel class remaining after new fetch on first 10 products
    let container = document.querySelector('#product-grid.grid--custom');
    for (let i = 0; i <= 9; i++) {
      if (container) {
        if (container.children[i]?.classList.contains('scroll-trigger--cancel')) {
          container.children[i].classList.remove('scroll-trigger--cancel');
        }
      }
    }
  }

  refreshFilters() {
    const filterWrapper = document.querySelector('.dossier-filter-wrapper');
    if(filterWrapper) {
      filterWrapper.querySelectorAll('input').forEach((el) => (el.checked = false));
      filterWrapper.querySelectorAll('.clear-button').forEach((el) => el.remove());
    }
    document.querySelectorAll('.widget__header.active, .facets.active').forEach(el => el.classList.remove('active'));

    const filterFooter = document.querySelector('.dossier-filter__footer');
    if (filterFooter) filterFooter.innerHTML = '';
  }

  deactivateFilters() {
    //deactivate filters with clear all buttons
    document.addEventListener('click', e => {
      if (e.target.classList.contains('clearall')) {
        //clear all filters
        let newUrl;
        if (window.location.pathname.split('/').length == 4) {
          newUrl = `${window.location.origin}${window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/'))}`
        } else {
          newUrl = `${window.location.origin}${window.location.pathname}`
        }
        window.history.pushState("", "", newUrl);
        this.fetchFilters(e);
        //uncheck all filters
        document.querySelectorAll('.dossier-filter-wrapper input').forEach(el => {
          el.checked = false;
        })
        //activate refetch
        document.querySelector('#brands-filter').parentElement.onSubmitHandler(e);
        document.querySelector('#genders-filter').parentElement.onSubmitHandler(e);
      } else if (e.target.classList.contains('clear')) {
        //clear current set of filters
        if (e.target.closest('div.price')) {
          document.querySelectorAll('#price-filter input').forEach(el => {
            el.checked = false;
          })
          // elimintate filter from url
          let url = new URL(window.location.href);
  
          // Remove all search parameters with the name 'filter.p.price'
          url.searchParams.delete('filter.v.price.gte');
          url.searchParams.delete('filter.v.price.lte');
  
          // Reconstruct the URL without the unwanted parameters
          let newURL = url.origin + url.pathname + url.search + url.hash;
          window.history.pushState("", "", newURL);
          //activate refetch
          document.querySelector('#brands-filter').parentElement.onSubmitHandler(e);
          document.querySelector('#genders-filter').parentElement.onSubmitHandler(e);
          //make full range
        }
        else if (e.target.closest('div.genders')) {
          //uncheck checkboxes
          document.querySelectorAll('#genders-filter input').forEach(el => {
            el.checked = false;
          })
          //activate refetch
          document.querySelector('#genders-filter').parentElement.onSubmitHandler(e)
        }
        else if (e.target.closest('div.brands')) {
          //uncheck checkboxes
          document.querySelectorAll('#brands-filter input').forEach(el => {
            el.checked = false;
          })
          //activate refetch
          document.querySelector('#brands-filter').parentElement.onSubmitHandler(e)
        }
        else if (e.target.closest('div.scents')) {
          //eliminate filter from url
          let new_path = window.location.pathname
          if (new_path.split('/').length == 4) {
            let updated_path = new_path.split('/');
            updated_path.pop()
            let new_url = window.location.origin + updated_path.join('/')
            window.history.pushState("", "", new_url);
          }
          //uncheck radio
          document.querySelectorAll('#scents-filter input').forEach(el => {
            el.checked = false
          })
          //activate refetch
          document.querySelector('#brands-filter').parentElement.onSubmitHandler(e);
          document.querySelector('#genders-filter').parentElement.onSubmitHandler(e);
        }
      }
    })
  }

  filterFilters(event) {
    let firstLoad = true;

    //filters dossier custom filter from CAT page based on products
    let genderFilters = document.querySelector('#genders-filter');
    let priceFilters = document.querySelector('#price-filter');
    let scentFilters = document.querySelector('#scents-filter');
    let brandFilters = document.querySelector('#brands-filter');
  
    const toggleFilters = (filterClass) => {
      //show or hides filter based on products
  
      let products = document.querySelectorAll('#product-grid .grid__item .card-wrapper');

      if (filterClass != undefined) {
        //filter other filteres besides the one clicked
        if (!brandFilters.querySelector(`.${filterClass}`)) {
          //brands
          let availableBrands = [] // contains all available brands in current filter results
          products.forEach(product => {
            let brand = product.dataset.vendor;
            if (!availableBrands.includes(brand)) {
              availableBrands.push(brand)
            }
          })
          //filter brands
          brandFilters.querySelectorAll('input').forEach(input => {
            if (input.value == 'Maison Francis Kurkdjian' ? !availableBrands.some(e => e && e.includes('MFK')) : !availableBrands.some(e => e && e.includes(input.value))) {
              input.parentElement.style.display = 'none'
            }
            else {
              input.parentElement.removeAttribute('style')
            }
          })
        }
        if (!scentFilters.querySelector(`.${filterClass}`)) {
          //scents
          let availableScents = [] // contains all available scents in current filter results
          products.forEach(product => {
            let scent = product.dataset.scent;
            if (!availableScents.includes(scent)) {
              availableScents.push(scent)
            }
          })
          //filter scents
          scentFilters.querySelectorAll('input').forEach(input => {
            if (!availableScents.some(e => e.includes(input.value))) {
              input.parentElement.style.display = 'none'
            }
            else {
              input.parentElement.removeAttribute('style')
            }
          })
        }
        if (!genderFilters.querySelector(`.${filterClass}`)) {
          //genders
          let availableGenders = [] // contains all available genders in current filter results
          products.forEach(product => {
            let gender = product.dataset.gender;
            if (!availableGenders.includes(gender)) {
              availableGenders.push(gender);
            }
          })
          //filter genders
          genderFilters.querySelectorAll('input').forEach(input => {
            if (!availableGenders.some(e => e.includes(input.value))) {
              input.parentElement.style.display = 'none'
            }
            else {
              input.parentElement.removeAttribute('style')
            }
          })
        }
        if (!priceFilters.querySelector(`.${filterClass}`)) {
          //price
          let availablePrices = [] // contains all available prices in current filter results
          products.forEach(product => {
            let price = product.dataset.price
            if (!availablePrices.includes(price)) {
              availablePrices.push(price)
            }
          })
          //filter prices inputs
          priceFilters.querySelectorAll('input').forEach(input => {
            if (!availablePrices.some(e => e.includes(input.value))) {
              input.parentElement.style.display = 'none'
            }
            else {
              input.parentElement.removeAttribute('style')
            }
          })
        }
      }
      else {
        //load case when we have filters on
        if (document.querySelector(".CAT-filters-wrapper:has(.clear)")) {
          //price
          let availablePrices = [] // contains all available prices in current filter results
          products.forEach(product => {
            let price = product.dataset.price
            if (!availablePrices.includes(price)) {
              availablePrices.push(price)
            }
          })
          //filter prices inputs
          priceFilters.querySelectorAll('input').forEach(input => {
            if (!availablePrices.some(e => e.includes(input.value))) {
              input.parentElement.style.display = 'none'
            }
            else {
              input.parentElement.removeAttribute('style')
            }
          })
          //scents
          let availableScents = [] // contains all available scents in current filter results
          products.forEach(product => {
            let scent = product.dataset.scent;
            if (!availableScents.includes(scent)) {
              availableScents.push(scent)
            }
          })
          //filter scents
          scentFilters.querySelectorAll('input').forEach(input => {
            if (!availableScents.some(e => e && e.includes(input.value))) {
              input.parentElement.style.display = 'none'
            }
            else {
              input.parentElement.removeAttribute('style')
            }
          })
          //brands
          let availableBrands = [] // contains all available brands in current filter results
          products.forEach(product => {
            let brand = product.dataset.vendor;
            if (!availableBrands.includes(brand)) {
              availableBrands.push(brand)
            }
          })
          //filter brands
          brandFilters.querySelectorAll('input').forEach(input => {
            if (input.value == 'Maison Francis Kurkdjian' ? !availableBrands.some(e => e && e.includes('MFK')) : !availableBrands.some(e => e && e.toLowerCase().includes(input.value.toLocaleLowerCase()))) {
              input.parentElement.style.display = 'none'
            }
            else {
              input.parentElement.removeAttribute('style')
            }
          })
          //genders
          let availableGenders = [] // contains all available genders in current filter results
          products.forEach(product => {
            let gender = product.dataset.gender;
            if (!availableGenders.includes(gender)) {
              availableGenders.push(gender);
            }
          })
          //filter genders
          genderFilters.querySelectorAll('input').forEach(input => {
            if (!availableGenders.includes(input.value)) {
              input.parentElement.style.display = 'none'
            }
            else {
              input.parentElement.removeAttribute('style');
            }
          })
        }
      }
      yotpoWidgetsContainer.initWidgets(); //render yotpo reviews
    }
  
    //filters filters based on products
    if (event) {
      let filterClass;
      event.target.classList.forEach(value => {
        if (value.includes('filter')) {
          filterClass = value
        }
      })
      if (event.target.offsetParent?.classList.contains('CAT-header-wrapper')) {
        filterClass = 'header-change'
      }
      if (event.target.classList?.contains('clear')) {
        filterClass = 'clear-button-pushed'
      }
      toggleFilters(filterClass)
    }
    else {
      //first load
      if (firstLoad) {
        if (document.querySelector('.clear-button')) {
          toggleFilters();
        }
        firstLoad = false
      }
    }
  
    //price case by url params
    let urlSearchParams = new URLSearchParams(window.location.search);

    if (urlSearchParams.has('filter-price')) {
      //adjust products shown
      const urlPriceParam = urlSearchParams.get('filter-price');
      let activePriceFilters = urlPriceParam.split('-')
      document.querySelectorAll('#product-grid .grid__item .card-wrapper').forEach(el => {
        if (!activePriceFilters.includes((el.dataset.price / 100).toString())) {
          el.parentElement.style.display = 'none'
        }
        else {
          el.parentElement.removeAttribute('style')
        }
      })
      //adjust filters to be checked on unchecked depending on url param
      priceFilters.querySelectorAll('input').forEach(input => {
        if (activePriceFilters.includes(input.value) && input.checked == false) {
          input.checked = true
        }
      })
      //adjust filters
      let filterClass;
      if (event) {
        event.target.classList.forEach(value => {
          if (value.includes('filter')) {
            filterClass = value
          }
        })
      }
      if (!priceFilters.querySelector(`.${filterClass}`)) {
        priceFilters.querySelectorAll('input').forEach(input => {
          if (!activePriceFilters.includes(input.value)) {
            input.parentElement.style.display = 'none'
          }
          else {
            input.parentElement.removeAttribute('style')
          }
        })
      }
      //get product count
      let visibleProductsCount = 0;
      document.querySelectorAll('#product-grid .grid__item').forEach(el => {
        if (el.style.display != 'none') {
          visibleProductsCount++
        }
      })
      //adjust promo cards
      document.querySelectorAll('#product-grid .promo-card').forEach(el => {
        if (el.dataset.min > visibleProductsCount) {
          el.style.display = 'none'
        }
        else {
          el.removeAttribute('style')
        }
      })
      //adjust products count
      document.querySelector('.CAT-header-products-number').innerText = `${visibleProductsCount} Products`
    }
  }

  toggleDossierFilter() {
    let container = document.querySelector('.dossier-filter-wrapper');
    if (container) {
      let openButton = document.querySelector(".custom-dossier-filter-button__filter");
      let closeButton = container.querySelector(".close-icon");
  
      if (openButton) {
        openButton.addEventListener('click', (e) => {
          openButton.classList.toggle('open');
          container.classList.toggle('open');
        })
      }
      if (closeButton) {
        closeButton.addEventListener('click', (e) => {
          openButton.classList.remove('open');
          container.classList.remove('open');
        })
      }
    }
  }

  toggleDossierSort() {
    let container = document.querySelector('.dossier-sort__modal');
    let openButton = document.querySelector(".custom-dossier-filter-button__sort");

    if (openButton) {
      openButton.addEventListener('click', (e) => {
        // Prevent the click inside the button from propagating to the document
        e.stopPropagation();
        container.classList.toggle('open');
      })
    }
  }

  changeDossierSortTitle() {
    let container = document.querySelector('.dossier-sort__modal');
    if (container) {
      container.addEventListener('click', (e) => {
        if (e.target.matches('label')) {
          let newValue = e.target.textContent.trim();
          let titleSort = document.querySelector('.dossier-sort__title span');
          if (titleSort) {
            titleSort.innerText = newValue;
          }
        }
      });
    }
  }

  toggleDossierFilterwidgets() {
    let container = document.querySelector('.dossier-filter-wrapper')
    if (container) {
      container.addEventListener('click', (e) => {
        const header = e.target.closest('.widget__header');

        if (header) {
          const facets = header.nextElementSibling?.classList.contains('facets') ? header.nextElementSibling : null;

          if (facets) {
            facets.classList.toggle('active');
            header.classList.toggle('active');
          }
        }
      })
    }
  }

  toggleDossierFilterwidgets() {
    let container = document.querySelector('.dossier-filter-wrapper')
    if (container) {
      container.addEventListener('click', (e) => {
        const header = e.target.closest('.widget__header');

        if (header) {
          const facets = header.nextElementSibling?.classList.contains('facets') ? header.nextElementSibling : null;

          if (facets) {
            facets.classList.toggle('active');
            header.classList.toggle('active');
          }
        }
      })
    }
  }

  async fetchFilters(event) {
    //refetch filters
    if (document.querySelector(".CAT-filters-wrapper")) {
      let url = window.location.origin + window.location.pathname
      let urlParams = window.location.search.replace('?', '')
      let section_id = document.querySelector(".CAT-filters-wrapper aside").dataset.id;
      let fetchUrl = `${url}?section_id=${section_id}&${urlParams}`
      let response = await fetch(fetchUrl)
      let results = await response.text() //html result

      const parsedHTML = new DOMParser().parseFromString(results, 'text/html');
      
      //update brands
      if (!event.target.classList.contains('brand-filter') || (document.querySelectorAll('#brands-filter input:checked').length == 0)) {
        document.querySelector('#brands-filter').innerHTML = parsedHTML.querySelector('#brands-filter').innerHTML;
      }
      document.querySelector('.dossier-filter__body .brands .title-wrapper').innerHTML = parsedHTML.querySelector('.dossier-filter__body .brands .title-wrapper').innerHTML;

      //update genders
      document.querySelector('#genders-filter').innerHTML = parsedHTML.querySelector('#genders-filter').innerHTML;
      document.querySelector('.dossier-filter__body .genders .title-wrapper').innerHTML = parsedHTML.querySelector('.dossier-filter__body .genders .title-wrapper').innerHTML;

      //update price
      document.querySelector('#price-filter').innerHTML = parsedHTML.querySelector('#price-filter').innerHTML;
      document.querySelector('.dossier-filter__body .price .title-wrapper').innerHTML = parsedHTML.querySelector('.dossier-filter__body .price .title-wrapper').innerHTML;
  
      //update scents
      document.querySelector('#scents-filter').innerHTML = parsedHTML.querySelector('#scents-filter').innerHTML;
      document.querySelector('.dossier-filter__body .scents .title-wrapper').innerHTML = parsedHTML.querySelector('.dossier-filter__body .scents .title-wrapper').innerHTML;

      //update footer
      document.querySelector('.dossier-filter__footer').innerHTML = parsedHTML.querySelector('.dossier-filter__footer').innerHTML;
  
      this.toggleDossierFilter();
      this.filterFilters(event);
    }
  }
}

// Create an instance of the class
const extraFiltersSettings = new ExtraFiltersSettings();

// Call the init method to execute all the functions
extraFiltersSettings.init();

//END custom dossier logic